import React, { Component } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

class CustomReportReviewQuestionParent extends Component {
  render() {
    const { pageName, pageQuestions } = this.props

    return (
      <span>
        {pageName}
      </span>
    )
  }
}

CustomReportReviewQuestionParent.propTypes = {
  pageQuestions: PropTypes.arrayOf(
    PropTypes.shape({
      questionId: PropTypes.number.isRequired,
      textTranslationIdentifier: PropTypes.string.isRequired
    })
  ).isRequired,
  pageName: PropTypes.string.isRequired
}
export default CustomReportReviewQuestionParent



// WEBPACK FOOTER //
// ./src/components/custom-report/Modals/QuestionSelection/CustomReportReviewQuestionParent.jsx